"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var find_1 = __importDefault(require("lodash/find"));
var compact_1 = __importDefault(require("lodash/compact"));
var getAddressComponent = function (geoResults, type, valueType) {
    if (valueType === void 0) { valueType = 'long'; }
    var x = (0, find_1.default)(geoResults.address_components, function (c) {
        return c.types.includes(type);
    });
    if (x)
        return valueType === 'long' ? x.long_name : x.short_name;
    else
        return null;
};
function default_1(geocoderResult) {
    var streetNumber = getAddressComponent(geocoderResult, 'street_number');
    var streetName = getAddressComponent(geocoderResult, 'route');
    var postalCode = getAddressComponent(geocoderResult, 'postal_code');
    var postalCodeSuffix = getAddressComponent(geocoderResult, 'postal_code_suffix');
    var address = {
        address1: (0, compact_1.default)([streetNumber, streetName]).join(' '),
        city: getAddressComponent(geocoderResult, 'locality') || '',
        state: getAddressComponent(geocoderResult, 'administrative_area_level_1') || '',
        zip: (0, compact_1.default)([postalCode, postalCodeSuffix]).join('-'),
        country: getAddressComponent(geocoderResult, 'country', 'short') || '',
    };
    return address;
}
exports.default = default_1;
